import img1 from '../../img/02_Halaman-furniture/1.png';
import img2 from '../../img/02_Halaman-furniture/2.png';
import img3 from '../../img/02_Halaman-furniture/3.png';
import img4 from '../../img/02_Halaman-furniture/4.png';
import img5 from '../../img/02_Halaman-furniture/5.png';
import img6 from '../../img/02_Halaman-furniture/6.png';
import img7 from '../../img/02_Halaman-furniture/7.png';

export const objectProduct = [
    {
        name : 'Patio armchair, blue',
        pathImg : img1,
        bg : '#E9F1F3'
    },
    {
        name : 'Patio armchair, green',
        pathImg : img2,
        bg : '#E9F3ED'
    },
    {
        name : 'Patio armchair, orange',
        pathImg : img3,
        bg : '#FFEDDF'
    },
    {
        name : 'KodyArmchair patchwork',
        pathImg : img4,
        bg : '#E9F1F3'
    },
    {
        name : 'Arck armchair, pink',
        pathImg : img5,
        bg : '#FFF0EE'
    },
    {
        name : 'Patio armchair, blue',
        pathImg : img6,
        bg : '#E9F1F3'
    },
    {
        name : 'Patio armchair, green',
        pathImg : img7,
        bg : '#E9F3ED'
    },
    {
        name : 'Patio armchair, blue',
        pathImg : img4,
        bg : '#E9F1F3'
    },
]